import { ColocaStatusPill } from "@/shared/components/data-display/ColocaStatusPill";
import { cn } from "@/shared/lib/utils";

import { useCryptoSwapLabels } from "../../hooks/useCryptoSwapLabels";
import type { OtcSellOrderStatus } from "../../types/cryptoSell.types";
import { isLiveSale, sellPillVariant } from "../../utils/cryptoSellStatus";

export interface CryptoSellStatusPillProps {
  status: OtcSellOrderStatus;
  size?: "default" | "sm";
  className?: string;
}

/** The label always renders; the colour repeats it. The dot pulses while something can still move. */
export function CryptoSellStatusPill({ status, size = "default", className }: CryptoSellStatusPillProps) {
  const labels = useCryptoSwapLabels();

  return (
    <ColocaStatusPill variant={sellPillVariant(status)} size={size} className={className}>
      <span
        aria-hidden="true"
        className={cn("size-1.5 shrink-0 rounded-full bg-current", isLiveSale(status) && "animate-pulse")}
      />
      {labels.sellStatus(status)}
    </ColocaStatusPill>
  );
}
